import { render, staticRenderFns } from "./InfoListTag.vue?vue&type=template&id=aa658224&scoped=true&"
import script from "./InfoListTag.vue?vue&type=script&lang=ts&"
export * from "./InfoListTag.vue?vue&type=script&lang=ts&"
import style0 from "./InfoListTag.vue?vue&type=style&index=0&id=aa658224&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa658224",
  null
  
)

export default component.exports